<template>
  <div class="Popup" v-if="isShow">
    <div class="popup-content-wrap">
      <div class="popup-head">
        {{ popData.title }}
      </div>
      <div class="popup-body">
        <div
          v-if="popData.description && popData.description !== ''"
          v-html="popData.description"
        ></div>
        <slot name="content"></slot>
      </div>
      <div class="popup-footer">
        <button type="button" class="popup-button" @click="closePopup">
          {{ popData.confirm }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Popup",
  props: {
    isShow: {
      type: Boolean,
      required: true,
      default: false,
    },
    popData: {
      type: Object,
      default() {
        return {
          description: "",
          title: "",
          confirm: "확인",
        };
      },
    },
    closePopup: {
      type: Function,
      default() {
        return {};
      },
    },
  },
  methods: {
    nl2br(str) {
      return str.replace(/\n/g, "<br />");
    },
  },
};
</script>
<style lang="scss" scoped>
.Popup {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
  /* padding: 0 20px; */
  display: flex;
  align-items: center;
  justify-content: center;
  .popup-content-wrap {
    width: 80%;
    background: white;
    overflow: hidden;
    border-radius: 16px;
  }

  .popup-head {
    background: #eb3246;
    padding: 20px 0;
    text-align: center;
    color: #fff;
    font-size: 14px;
  }

  .popup-body {
    max-height: 380px;
    overflow-y: scroll;
    padding: 12px;
    text-align: center;
    background: #ffffff;
  }

  .popup-content {
    width: 100%;
    background: white;
    overflow: hidden;
    font-size: 14px;
    word-break: break-all;
  }

  .popup-footer {
    display: flex;
    justify-content: stretch;
    flex-direction: row;
    border-top: 1px solid #c5c5c5;
  }

  .popup-button {
    flex: 1;
    margin: 0;
    padding: 20px;
    color: #333;
    border-right: 1px solid #c5c5c5;
    border-radius: 0;
    background: #fff;
    &:first-of-type {
      border-radius: 0 0 0 16px;
    }
    &:last-of-type {
      border: none;
      border-radius: 0 0 16px 0;
    }
    &:active {
      background: #fff;
    }
    &.oneButton {
      &:first-of-type {
        border-radius: 0 0 16px 16px;
      }
      &:last-of-type {
        border: none;
        border-radius: 0 0 16px 16px;
      }
    }
  }
}
</style>
